import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { AnalyticsView } from "./AnalyticsView";
import { App } from "./App";
import { QueueView } from "./QueueView";
import { ValidateView } from "./ValidateView";
import "./styles.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <QueueView /> },
      { path: "documents/:id", element: <ValidateView /> },
      { path: "analytics", element: <AnalyticsView /> },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
